import React from "react";

import Icon       from "_components/atoms/icon";
import Image      from "_components/atoms/image";
import Typography from "_components/atoms/typography";
import useStyles  from "_styles/molecules/TopPointScoreCard";

const TopPointScoreCard = React.memo ( function TopPointScoreCard ( { authorProfileImage, authorName, fanRank, points, coins } ) {
	const { classes } = useStyles ( { fanRank } );

	return (
		<div className = { classes.topPointsContainer }>
			<div className = { classes.topSection }>
				<div className = { classes.topPointsAvatarContainer }>
					<div className = { classes.topPointsAvatar }>
						<Image className = { classes.img }
							src = { authorProfileImage }
						/>

						<div className = { classes.topPointsMedal }>
							{
								fanRank === 1 ? (
									// <GoldMedalIcon className = { classes.svgIcon } />
									<Icon sameInBothTheme
										className = { classes.svgIcon }
										name = "goldMedalIcon"
									>
									</Icon>
								) : fanRank === 2 ? (
									<Icon sameInBothTheme
										className = { classes.svgIcon }
										name = "silverMedalIcon"
									>
									</Icon>
								) : (
									<Icon sameInBothTheme
										className = { classes.svgIcon }
										name = "bronzeMedalIcon"
									>
									</Icon>
								)
							}
						</div>
					</div>
				</div>
			</div>

			<div className = { classes.topPointsPointsText }>
				<Typography
					className = "fontBold"
					color     = "primary"
					title     = { authorName }
					variant   = "body2"
				/>
			</div>

			<div className = { classes.topPointsPointsText }>
				<Typography
					className = "fontBold"
					color     = "primary"
					title     = { Math.floor ( points ) }
					variant   = "body2"
				/>
			</div>

			<div className = { classes.coinsContainer }>
				<Typography
					className = { classes.coinText }
					title     = { coins }
					variant   = "body1"
				/>

				<Icon sameInBothTheme
					className = { classes.rooterCoinIcon }
					name = "rooterCoinIcon"
				/>
			</div>
		</div>
	);
} );

export default TopPointScoreCard;
